import {exportRequest, postRequest} from '@/libs/axios';

import paymeRequest from '@/utils/paymeRequest'

// api/app.js
import axios from 'axios';

// get实例
export const login = (params) => {
    return postRequest('/ndt/auth/login', params)
}
export const logout = (params) => {
    return postRequest('/ndt/auth/logout', params)
}
export const permission = (params) => {
    return postRequest('/ndt/user/permission', params)
}
export const stationPage = (params) => {
    return postRequest('/ndt/station/page', params)
}

export const aisleCreate = (params) => {
    return postRequest('/ndt/aisle/create', params)
}

export const shelfCreate = (params) => {
    return postRequest('/ndt/shelf/create', params)
}
export const siteCreate = (params) => {
    return postRequest('/ndt/site/create', params)
}

export const printSiteLabel = (params) => {
    return exportRequest('/ndt/site/generateSiteLabel', params);
};

export const warehouseCreate = (params) => {
    return postRequest('/ndt/warehouse/create', params)
}

export const shelfBarcode = (params) => {
    return postRequest('/ndt/shelf/barcode', params)
}

export const warehouseUpdate = (params) => {
    return postRequest('/ndt/warehouse/update', params)
}

export const aisleUpdate = (params) => {
    return postRequest('/ndt/aisle/update', params)
}


export const shelfUpdate = (params) => {
    return postRequest('/ndt/shelf/update', params)
}
export const siteUpdate = (params) => {
    return postRequest('/ndt/site/update', params)
}
export const roleGet = (params) => {
    return postRequest('/ndt/role/get', params)
}

export const roleUpdate = (params) => {
    return postRequest('/ndt/role/update', params)
}

export const roleCreat = (params) => {
    return postRequest('/ndt/role/create', params)
}

export const roleMenuUpdate = (params) => {
    return postRequest('/ndt/role/menu/update', params)
}

export const roleExternal = (params) => {
    return postRequest('/ndt/role/external', params)
}

export const userSitesl = (params) => {
    return postRequest('/ndt/user/sites', params)
}
export const allSitesl = (params) => {
    return postRequest('/ndt/user/all/sites', params)
}

export const orderSummary = (params) => {
    return postRequest('/ndt/order/summary', params)
}
export const statisticsOrderMoney = (params) => {
    return postRequest('/ndt/home/statistics/orderAmount', params)
}
export const orderTrack = (params) => {
    return postRequest('/ndt/order/track', params)
}
export const financeOrderStatistics = (params) => {
    return postRequest('/ndt/order/finance/statistics', params)
}
export const siteZipcode = (params) => {
    return postRequest('/ndt/site/zipcode', params)
}
export const orderStatistics = (params) => {
    return postRequest('/ndt/order/statistics', params)
}
export const updatePaymentStatus = (params) => {
    return postRequest('/ndt/order/update/payStatus', params)
}
export const updateOrderBarCodeNo = (params) => {
    return postRequest('/ndt/order/update/barCodeNo', params)
}
export const orderWeigh = (params) => {
    return postRequest('/ndt/order/weigh', params)
}
export const pageWeighingLog = (params) => {
    return postRequest('/ndt/module/weighingLog/page', params)
}
export const userUpdatePassword = (params) => {
    return postRequest('/ndt/user/update/password', params)
}
export const userCreate = (params) => {
    return postRequest('/ndt/user/create', params)
}
export const userUpdate = (params) => {
    return postRequest('/ndt/user/update', params)
}
export const roleList = (params) => {
    return postRequest('/ndt/role/list', params)
}

export const dictGet = (params) => {
    return postRequest('/ndt/dict/get', params)
}

export const getOutboundInfo = (params) => {
    return postRequest('/ndt/order/outbound/infos', params)
}

export const getSortingBoxList = (params) => {
    return postRequest('/ndt/module/sortingBox/page', params)
}

export const getOrdersByBoxNum = (params) => {
    return postRequest('/ndt/module/sortingBox/order/page', params)
}
export const getCustomerAvailablePoints = (params) => {
    return postRequest('/ndt/module/customer/availablePoints', params)
}
export const operateOrderOutbound = (params) => {
    return postRequest('/ndt/order/outbound/operate', params)
}

export const doPayMeOutBound = (params) => {
    return postRequest('/ndt/order/outbound/payMe/payment', params)
}
export const getPayLogList = (params) => {
    return postRequest('/ndt/payLog/page', params)
}
export const getPayLogDetail = (params) => {
    return postRequest('/ndt/payLog/detail', params)
}
export const selectStatistics = (params) => {
    return postRequest('/ndt/order/select/statistics', params)
}
export const paymentOutbound = (params) => {
    return postRequest('/ndt/order/paymentOutbound', params)
}

// businessType 直接拼接到URL，formData直接传，onUploadProgress可选
export const uploadFile = (businessType, formData, onUploadProgress) => {
    return axios.post(
        `/ndt/v2/module/ossStorage/uploadFile/${businessType}`,
        formData,
        {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress
        }
    );
};

//payme接口
export function preparePayment(params) {
    return paymeRequest({
        url: '/order/preparePayment', // 相对路径
        method: 'post',
        data: params
    })
}


export function checkPaymentStatus(params) {
    return paymeRequest({
        url: '/order/pollOrderStatus', // 相对路径
        method: 'post',
        data: params
    })
}

export function doCancelPayment(params) {
    return paymeRequest({
        url: '/order/cancelPayment', // 相对路径
        method: 'post',
        data: params
    })
}
